// extracted by mini-css-extract-plugin
export var bg = "index-module--bg--kbmvD";
export var cursor = "index-module--cursor--NDHa1";
export var quotation = "index-module--quotation--BWD3f";
export var section = "index-module--section--ZlGJo";